import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import websitePage, { headerTypes, footerTypes } from 'hoc/websitePage/websitePage';

import SectionHowItWorks from './patterns/SectionHowItWorks/SectionHowItWorks';
import SectionCustomCovarage from './patterns/SectionCustomCovarage/SectionCustomCovarage';
import SectionCustomerTarget from './patterns/SectionCustomerTarget/SectionCustomerTarget';
import SectionKnowMore from './patterns/SectionKnowMore/SectionKnowMore';
import SectionForm from './patterns/SectionForm/SectionForm';
import SectionHero from './patterns/SectionHero/SectionHero';
import SectionOldInsurances from './patterns/SectionOldInsurances/SectionOldInsurances';
import SectionFAQ from './patterns/SectionFAQ/SectionFAQ';
import SectionFeatures from './patterns/SectionFeatures/SectionFeatures';
import SectionOldInsurancesGallery
  from './patterns/SectionOldInsurancesGallery/SectionOldInsurancesGallery';

function Insurance({ onFormVisibilityChange, onFormAnchorPosition }) {
  const { formatMessage } = useContext(NuDsContext);
  const cardsArea = formatMessage({ id: 'cms.lifeInsurancePage.cardsArea' });

  const cardComponentsMap = {
    SectionFAQ,
  };

  return (
    <>
      <SectionHero />
      <SectionForm
        onFormVisibilityChange={onFormVisibilityChange}
        onFormAnchorPosition={onFormAnchorPosition}
      />
      <SectionOldInsurances />
      <SectionOldInsurancesGallery />
      <SectionHowItWorks />
      <SectionCustomCovarage />
      <SectionCustomerTarget />
      <SectionFeatures />
      {cardsArea.map(({ componentName, id }, index) => {
        const CardComponent = cardComponentsMap[componentName];

        if (!CardComponent) return null;

        return (
          <CardComponent
            key={id}
            index={index}
          />
        );
      })}
      <SectionKnowMore />
    </>
  );
}

Insurance.propTypes = {
  onFormAnchorPosition: PropTypes.func.isRequired,
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default websitePage({
  routeKey: 'INSURANCE',
  header: headerTypes.PRODUCT_PAGE,
  footer: footerTypes.INSURANCE,
})(Insurance);
